import React from "react";
import { useSelector } from "react-redux";

export default function TermosDeUso() {
    const user = useSelector((state) => state.auth.user);

    return (
        <div className={"d-flex flex-column gap-32" + (user ? "" : " unauthenticated-terms")}>
            {user ? (
                <div className="headerPageContainer">
                    <span className="tt-24 bold color-gray-09">Termos de Uso</span>
                </div>
            ) : null}

            <div className="d-flex flex-column gap-24" style={{ backgroundColor: "#FFFFFF", borderRadius: 8, padding: 24 }}>
                <span className="tt-18 bold color-gray-09">Termos de Uso e Política de Privacidade - Painel do Cliente Lumi</span>

                <span className="tt-18 color-gray-09">
                    Bem-vindo ao <strong>Painel do Cliente Lumi</strong>, ambiente destinado exclusivamente a empresas contratantes (<strong>Clientes B2B</strong>) para gestão das informações relacionadas ao uso do aplicativo Lumi por seus colaboradores.
                </span>

                <span className="tt-18 color-gray-09">Ao acessar o Painel, você concorda integralmente com estes Termos de Uso e com esta Política de Privacidade. Recomendamos a leitura atenta deste documento antes de utilizar a plataforma.</span>

                <span className="tt-16 bold color-gray-09">1. Definições</span>

                <ul className="tt-18 color-gray-09">
                    <li>Lumi: Plataforma composta por aplicativo, painel corporativo e outros serviços digitais relacionados.</li>
                    <li>Cliente corporativos: Empresa que contrata o Lumi e tem acesso ao Painel do Cliente.</li>
                    <li>Usuário final: Colaborador, funcionário, prestador de serviços ou parceiro da empresa que utiliza o app Lumi.</li>
                    <li>Administrador(es) do Painel: Representante(s) autorizado(s) pela empresa Cliente para acesso e gestão do Painel.</li>
                    <li>Dados Organizacionais: Informações fornecidas pela empresa Cliente.</li>
                    <li>Dados de Colaboradores: Dados gerados pelo uso do aplicativo Lumi pelos Usuários Finais.</li>
                </ul>

                <span className="tt-16 bold color-gray-09">2. Aceitação dos Termos</span>

                <span className="tt-18 color-gray-09">Ao acessar o Painel, o Administrador confirma que:</span>

                <ul className="tt-18 color-gray-09">
                    <li>Leu e concorda com estes Termos e Política de Privacidade;</li>
                    <li>Está autorizado pela empresa Cliente a utilizar e administrar o Painel;</li>
                    <li>Atenderá às normas de sigilo e responsabilidade no uso das informações. Caso não concorde, o acesso deve ser imediatamente interrompido.</li>
                </ul>

                <span className="tt-16 bold color-gray-09">3. Finalidade do Painel do Cliente</span>

                <span className="tt-18 color-gray-09">O Painel do Cliente Lumi fornece recursos para:</span>

                <ol className="tt-18 color-gray-09">
                    <li>Acompanhamento do uso do app Lumi pelos colaboradores;</li>
                    <li>Visualização de métricas como engajamento, progresso em trilhas, adesão ao diagnóstico NR1 e outros indicadores;</li>
                    <li>Emissão de relatórios administrativos e gerenciais;</li>
                    <li>Gestão de acesso de colaboradores (cadastro, remoção, grupos, permissões);</li>
                    <li>Acesso a dashboards consolidados com informações gerais e segmentadas visando melhorias ou adequações legais.</li>
                </ol>

                <span className="tt-18 color-gray-09">
                    O Painel <strong>não</strong> oferece acesso a informações sensíveis de sessões de telepsicologia, relatórios clínicos, prontuários ou conteúdos protegidos pelo sigilo profissional.
                </span>

                <span className="tt-16 bold color-gray-09">4. Responsabilidades do Cliente e Administradores</span>

                <ul className="tt-18 color-gray-09">
                    <li>O Cliente e seus Administradores concordam em:</li>
                    <li>Utilizar o Painel exclusivamente para fins corporativos e legais;</li>
                    <li>Acessar somente informações pertinentes às suas responsabilidades;</li>
                    <li>Manter sigilo absoluto sobre dados de colaboradores;</li>
                    <li>Não compartilhar acessos, senhas ou exportações com terceiros não autorizados;</li>
                    <li>Garantir conformidade com a LGPD no uso interno dos dados acessados;</li>
                    <li>Notificar o Lumi em caso de acesso indevido, suspeita de violação ou incidentes de segurança.</li>
                    <li>A empresa é integralmente responsável pelo uso que seus Administradores fazem do Painel.</li>
                </ul>

                <span className="tt-16 bold color-gray-09">5. Obrigações do Lumi</span>

                <span className="tt-18 color-gray-09">O Lumi se compromete a:</span>

                <ul className="tt-18 color-gray-09">
                    <li>Fornecer acesso ao Painel conforme o plano contratado;</li>
                    <li>Manter a segurança, integridade e disponibilidade dos dados, dentro dos padrões técnicos e legais;</li>
                    <li>Adotar medidas de proteção compatíveis com a LGPD;</li>
                    <li>Informar o Cliente sobre mudanças relevantes na plataforma;</li>
                    <li>Monitorar e prevenir acessos não autorizados.</li>
                </ul>

                <span className="tt-16 bold color-gray-09">6. Dados Disponibilizados no Painel</span>

                <span className="tt-18 color-gray-09">O Cliente poderá visualizar, conforme o plano contratado:</span>

                <ul className="tt-18 color-gray-09 ">
                    <li>Dados cadastrais básicos dos colaboradores;</li>
                    <li>Status de acesso ao aplicativo;</li>
                    <li>Indicadores de uso;</li>
                    <li>Resultados agregados e anonimizados de diagnósticos organizacionais, como NR1;</li>
                    <li>Engajamento geral e por grupos;</li>
                    <li>Dados estatísticos e métricas não sensíveis.</li>
                </ul>

                <span className="tt-18 color-gray-09">Informações de telepsicologia nunca serão exibidas no Painel.</span>

                <ul className="tt-18 color-gray-09 ">
                    <li>Motivos de atendimento;</li>
                    <li>Conversas, mensagens ou prontuários;</li>
                    <li>Dados clínicos;</li>
                    <li>Identificação individualizada de condutas terapêuticas.</li>
                </ul>

                <span className="tt-16 bold color-gray-09">7. Propriedade Intelectual</span>

                <span className="tt-18 color-gray-09">Todo o conteúdo do Painel (dashboards, relatórios, algoritmos, interface, metodologias) pertence ao Lumi. O Cliente não adquire qualquer direito além do uso restrito previsto no contrato.</span>

                <span className="tt-16 color-gray-09">É vedado:</span>

                <ul className="tt-18 color-gray-09 ">
                    <li>Copiar, reproduzir ou distribuir qualquer parte do Painel;</li>
                    <li>Realizar engenharia reversa;</li>
                    <li>Utilizar dados para criação de produtos concorrentes.</li>
                </ul>

                <span className="tt-16 bold color-gray-09">8. Política de Privacidade do Painel</span>

                <span className="tt-18 color-gray-09">Esta Política descreve como os dados são coletados, tratados e protegidos no ambiente corporativo.</span>

                <span className="tt-18 bold color-gray-09">8.1 Dados Tratados</span>

                <span className="tt-18 color-gray-09">O Lumi poderá coletar e tratar:</span>

                <ul className="tt-18 color-gray-09 mt-0">
                    <li>Dados cadastrais do Cliente e de Administradores;</li>
                    <li>Dados de navegação no Painel (logs, acessos, IP, horário, páginas visualizadas);</li>
                    <li>Dados agregados e não sensíveis de colaboradores;</li>
                    <li>Dados operacionais para suporte, auditoria e segurança.</li>
                </ul>

                <span className="tt-18 bold color-gray-09">8.2 Finalidade do Tratamento</span>

                <span className="tt-18 color-gray-09">Os dados são utilizados para:</span>

                <ul className="tt-18 color-gray-09 mt-0">
                    <li>Disponibilização do Painel e suas funcionalidades;</li>
                    <li>Suporte técnico e segurança da informação;</li>
                    <li>Cumprimento de obrigações legais;</li>
                    <li>Geração de relatórios consolidados para o Cliente;</li>
                    <li>Melhoria contínua da plataforma.</li>
                </ul>

                <span className="tt-18 bold color-gray-09">8.3 Compartilhamento de Dados</span>

                <span className="tt-18 color-gray-09">O Lumi poderá compartilhar dados apenas:</span>

                <ul className="tt-18 color-gray-09 mt-0">
                    <li>Com prestadores de serviço essenciais à operação (ex.: servidores, ferramentas analíticas), sempre sob contrato de confidencialidade;</li>
                    <li>Com autoridades públicas, mediante ordem legal;</li>
                    <li>Com o próprio Cliente, conforme permissões do Painel. Nunca compartilharemos dados sensíveis ou clínicos de colaboradores.</li>
                </ul>

                <span className="tt-18 bold color-gray-09">8.4 Segurança da Informação</span>

                <span className="tt-18 color-gray-09">O Lumi adota:</span>

                <ul className="tt-18 color-gray-09 mt-0">
                    <li>Criptografia;</li>
                    <li>Controle de acesso;</li>
                    <li>Monitoramento contínuo de integridade;</li>
                    <li>Políticas internas de governança de dados;</li>
                    <li>Mecanismos de prevenção de incidentes.</li>
                </ul>

                <span className="tt-18 color-gray-09">Apesar disso, nenhum sistema é 100% livre de riscos. O Cliente concorda em adotar boas práticas internas de segurança.</span>

                <span className="tt-18 bold color-gray-09">9. Exportação de Dados</span>

                <span className="tt-18 color-gray-09">O Painel poderá permitir exportações (CSV, XLSX, PDF) de informações não sensíveis. Ao exportar, o Cliente assume total responsabilidade pela guarda, tratamento e proteção dos dados.</span>

                <span className="tt-18 bold color-gray-09">10. Cancelamento, Suspensão e Encerramento</span>

                <span className="tt-18 color-gray-09">O acesso ao Painel poderá ser:</span>

                <ul className="tt-18 color-gray-09 mt-0">
                    <li>Encerrado ao término do contrato corporativo;</li>
                    <li>Suspenso por falta de pagamento;</li>
                    <li>Bloqueado em casos de suspeita de uso indevido.</li>
                </ul>

                <span className="tt-18 color-gray-09">O Cliente poderá solicitar remoção de contas de Administradores a qualquer momento.</span>

                <span className="tt-16 bold color-gray-09">11. Atualizações dos Termos e da Política</span>

                <span className="tt-18 color-gray-09">O Lumi poderá atualizar este documento periodicamente. O uso contínuo do Painel implica concordância com a nova versão.</span>

                <span className="tt-16 bold color-gray-09">12. Legislação e Foro</span>

                <span className="tt-18 color-gray-09">Este documento é regido pelas leis brasileiras, incluindo a Lei Geral de Proteção de Dados – LGPD. Eventuais disputas serão resolvidas no foro da comarca de Porto Alegre/RS, salvo acordo contratual em contrário.</span>

                <span className="tt-16 bold color-gray-09">13. Contato</span>
                <span className="tt-16 color-gray-09">Para dúvidas, solicitações ou comunicações formais:</span>
                <span className="tt-18 color-gray-09">
                    E-mail: <strong>suporte@applumi.io</strong>
                </span>
                <span className="tt-16 bold color-gray-09">Ao acessar o Painel do Cliente Lumi, você concorda integralmente com estes Termos de Uso e Política de Privacidade.</span>
            </div>
        </div>
    );
}
